/*
 * axios数据请求
 * request请求拦截
 * response请求响应
 */

import axios from 'axios'
// import { Message } from 'element-ui'
// import store from '@/store'

// create an axios instance
const service = axios.create({
  // baseURL: 'https://us14.api.mailchimp.com/3.0/',
  // baseURL:'https://ebo.enabot.com/mailchimp/us14/',
  baseURL:'https://ebo.enabot.com/mailchimp/us21/',
  post: {
    'Content-Type': 'application/json;charset=utf-8'
  },

  timeout: 20000 // request timeout
})
// 请求拦截器
// service.interceptors.request.use(
//   config => {

//     if (store.getters.token) {
//       config.headers['Authorization'] = 'Bearer ' + getToken()
//     }
//     return config
//   },
//   error => {

//     console.log(error) // for debug
//     return Promise.reject(error)
//   }
// )

// 响应拦截器
// response interceptor
// service.interceptors.response.use(
//   response => {

//     // const res = response.data
//     // const code = parseInt(res.error.code)
//     return response.data
//     // if (code !== 0) {
//     //   handleError(code)
//     //   return Promise.reject(res.error || {code: 99998, msg: 'Error'})
//     // } else {
//     //   return res
//     // }
//   },
//   error => {
//     if(error.response)
//     return error
//   }
// )

export default service
